require("core-js/modules/esnext.global-this.js");
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define("tailwindcss-classnames", ["exports"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self).TailwindcssClassnames = {});
}(this, function (e) {
  "use strict";

  function t(e) {
    var o,
      r,
      i = "";
    if ("string" == typeof e || "number" == typeof e) i += e;else if ("object" == typeof e) if (Array.isArray(e)) for (o = 0; o < e.length; o++) e[o] && (r = t(e[o])) && (i && (i += " "), i += r);else for (o in e) e[o] && (i && (i += " "), i += o);
    return i;
  }
  function o() {
    for (var e, o, r = 0, i = ""; r < arguments.length;) (e = arguments[r++]) && (o = t(e)) && (i && (i += " "), i += o);
    return i;
  }
  var r = o,
    i = o,
    a = o,
    n = o,
    l = o,
    d = o,
    s = o,
    c = o,
    g = o,
    p = o,
    f = o,
    u = o,
    b = o,
    h = o,
    y = o,
    k = o,
    m = o,
    x = o,
    S = o,
    C = o,
    w = o,
    v = o,
    O = o,
    R = o,
    W = o,
    A = o,
    B = o,
    D = o,
    I = o,
    T = o,
    j = o,
    P = o,
    z = o,
    F = o,
    H = o,
    M = o,
    E = o,
    G = o,
    L = o,
    N = o,
    U = o,
    V = o,
    _ = o,
    q = o,
    J = o,
    K = o,
    Q = o,
    X = o,
    Y = o,
    Z = o,
    $ = o,
    ee = o,
    te = o,
    oe = o,
    re = o,
    ie = o,
    ae = o,
    ne = o,
    le = o,
    de = o,
    se = o,
    ce = o,
    ge = o,
    pe = o,
    fe = o,
    ue = o,
    be = o,
    he = o,
    ye = o,
    ke = o,
    me = o,
    xe = o,
    Se = o,
    Ce = o,
    we = o,
    ve = o,
    Oe = o,
    Re = o,
    We = o,
    Ae = o,
    Be = o,
    De = o,
    Ie = o,
    Te = o,
    je = o,
    Pe = o,
    ze = o,
    Fe = o,
    He = o,
    Me = o,
    Ee = o,
    Ge = o,
    Le = o,
    Ne = o,
    Ue = o,
    Ve = o,
    _e = o,
    qe = o,
    Je = o,
    Ke = o,
    Qe = o,
    Xe = o,
    Ye = o,
    Ze = o,
    $e = o,
    et = o,
    tt = o,
    ot = o,
    rt = o,
    it = o,
    at = o,
    nt = o,
    lt = o,
    dt = o,
    st = o,
    ct = o,
    gt = o,
    pt = o,
    ft = o,
    ut = o,
    bt = o,
    ht = o,
    yt = o,
    kt = o,
    mt = o,
    xt = o,
    St = o,
    Ct = o,
    wt = o,
    vt = o,
    Ot = o,
    Rt = o,
    Wt = o,
    At = o,
    Bt = o,
    Dt = o,
    It = o,
    Tt = o,
    jt = o,
    Pt = o,
    zt = o,
    Ft = o,
    Ht = o,
    Mt = o,
    Et = o,
    Gt = o,
    Lt = o,
    Nt = o,
    Ut = o,
    Vt = o,
    _t = o,
    qt = o,
    Jt = o,
    Kt = o,
    Qt = o,
    Xt = o,
    Yt = o,
    Zt = o,
    $t = o,
    eo = o,
    to = o,
    oo = o,
    ro = o,
    io = o,
    ao = o,
    no = o,
    lo = o,
    so = {
      screenReaders: r,
      backgroundAttachment: i,
      backgroundClip: a,
      backgroundOrigin: n,
      backgroundRepeat: l,
      backgroundOpacity: d,
      backgroundColor: s,
      backgroundPosition: c,
      backgroundSize: g,
      backgroundImage: p,
      gradientColorStops: f,
      borderStyle: u,
      divideStyle: b,
      outlineStyle: h,
      borderColor: y,
      borderOpacity: k,
      borderRadius: m,
      borderWidth: x,
      divideColor: S,
      divideOpacity: C,
      divideWidth: w,
      ringColor: v,
      ringWidth: O,
      ringOpacity: R,
      ringOffsetColor: W,
      ringOffsetWidth: A,
      outlineOffset: B,
      outlineWidth: D,
      outlineColor: I,
      borderCollapse: T,
      tableLayout: j,
      mixBlendMode: P,
      backgroundBlendMode: z,
      boxShadow: F,
      boxShadowColor: H,
      opacity: M,
      transitionProperty: E,
      transitionDuration: G,
      transitionTimingFunction: L,
      transitionDelay: N,
      animation: U,
      filter: V,
      backdropFilter: _,
      blur: q,
      brightness: J,
      contrast: K,
      dropShadow: Q,
      grayscale: X,
      hueRotate: Y,
      invert: Z,
      saturate: $,
      sepia: ee,
      backdropBlur: te,
      backdropBrightness: oe,
      backdropContrast: re,
      backdropGrayscale: ie,
      backdropHueRotate: ae,
      backdropInvert: ne,
      backdropOpacity: le,
      backdropSaturate: de,
      backdropSepia: se,
      flexDirection: ce,
      flexWrap: ge,
      alignItems: pe,
      alignContent: fe,
      alignSelf: ue,
      placeContent: be,
      placeItems: he,
      placeSelf: ye,
      justifyContent: ke,
      justifyItems: me,
      justifySelf: xe,
      flex: Se,
      flexBasis: Ce,
      flexGrow: we,
      flexShrink: ve,
      order: Oe,
      gridAutoFlow: Re,
      gridTemplateColumns: We,
      gridAutoColumns: Ae,
      gridColumn: Be,
      gridColumnStart: De,
      gridColumnEnd: Ie,
      gridTemplateRows: Te,
      gridAutoRows: je,
      gridRow: Pe,
      gridRowStart: ze,
      gridRowEnd: Fe,
      gap: He,
      padding: Me,
      margin: Ee,
      space: Ge,
      appearance: Le,
      pointerEvents: Ne,
      resize: Ue,
      userSelect: Ve,
      scrollSnap: _e,
      scrollBehavior: qe,
      touchAction: Je,
      cursor: Ke,
      caretColor: Qe,
      willChange: Xe,
      accentColor: Ye,
      scrollPadding: Ze,
      scrollMargin: $e,
      display: et,
      boxDecorationBreak: tt,
      boxSizing: ot,
      container: rt,
      float: it,
      clear: at,
      isolation: nt,
      objectFit: lt,
      overflow: dt,
      overscrollBehavior: st,
      position: ct,
      visibility: gt,
      breakBefore: pt,
      breakInside: ft,
      breakAfter: ut,
      objectPosition: bt,
      inset: ht,
      zIndex: yt,
      aspectRatio: kt,
      columns: mt,
      width: xt,
      minWidth: St,
      maxWidth: Ct,
      height: wt,
      minHeight: vt,
      maxHeight: Ot,
      fill: Rt,
      stroke: Wt,
      strokeWidth: At,
      hardwareAcceleration: Bt,
      scale: Dt,
      rotate: It,
      translate: Tt,
      skew: jt,
      transformOrigin: Pt,
      fontSmoothing: zt,
      fontStyle: Ft,
      fontVariantNumeric: Ht,
      listStylePosition: Mt,
      textAlign: Et,
      textDecoration: Gt,
      textTransform: Lt,
      textOverflow: Nt,
      verticalAlign: Ut,
      whitespace: Vt,
      wordBreak: _t,
      textDecorationStyle: qt,
      fontFamily: Jt,
      fontSize: Kt,
      fontWeight: Qt,
      letterSpacing: Xt,
      lineHeight: Yt,
      listStyleType: Zt,
      placeholderColor: $t,
      placeholderOpacity: eo,
      textColor: to,
      textOpacity: oo,
      content: ro,
      textIndent: io,
      textDecorationColor: ao,
      textDecorationThickness: no,
      textUnderlineOffset: lo
    },
    co = o;
  e.TW = so, e.accentColor = Ye, e.alignContent = fe, e.alignItems = pe, e.alignSelf = ue, e.animation = U, e.appearance = Le, e.aspectRatio = kt, e.backdropBlur = te, e.backdropBrightness = oe, e.backdropContrast = re, e.backdropFilter = _, e.backdropGrayscale = ie, e.backdropHueRotate = ae, e.backdropInvert = ne, e.backdropOpacity = le, e.backdropSaturate = de, e.backdropSepia = se, e.backgroundAttachment = i, e.backgroundBlendMode = z, e.backgroundClip = a, e.backgroundColor = s, e.backgroundImage = p, e.backgroundOpacity = d, e.backgroundOrigin = n, e.backgroundPosition = c, e.backgroundRepeat = l, e.backgroundSize = g, e.blur = q, e.borderCollapse = T, e.borderColor = y, e.borderOpacity = k, e.borderRadius = m, e.borderStyle = u, e.borderWidth = x, e.boxDecorationBreak = tt, e.boxShadow = F, e.boxShadowColor = H, e.boxSizing = ot, e.breakAfter = ut, e.breakBefore = pt, e.breakInside = ft, e.brightness = J, e.caretColor = Qe, e.classnames = co, e.clear = at, e.columns = mt, e.container = rt, e.content = ro, e.contrast = K, e.cursor = Ke, e.default = co, e.display = et, e.divideColor = S, e.divideOpacity = C, e.divideStyle = b, e.divideWidth = w, e.dropShadow = Q, e.fill = Rt, e.filter = V, e.flex = Se, e.flexBasis = Ce, e.flexDirection = ce, e.flexGrow = we, e.flexShrink = ve, e.flexWrap = ge, e.float = it, e.fontFamily = Jt, e.fontSize = Kt, e.fontSmoothing = zt, e.fontStyle = Ft, e.fontVariantNumeric = Ht, e.fontWeight = Qt, e.gap = He, e.gradientColorStops = f, e.grayscale = X, e.gridAutoColumns = Ae, e.gridAutoFlow = Re, e.gridAutoRows = je, e.gridColumn = Be, e.gridColumnEnd = Ie, e.gridColumnStart = De, e.gridRow = Pe, e.gridRowEnd = Fe, e.gridRowStart = ze, e.gridTemplateColumns = We, e.gridTemplateRows = Te, e.hardwareAcceleration = Bt, e.height = wt, e.hueRotate = Y, e.inset = ht, e.invert = Z, e.isolation = nt, e.justifyContent = ke, e.justifyItems = me, e.justifySelf = xe, e.letterSpacing = Xt, e.lineHeight = Yt, e.listStylePosition = Mt, e.listStyleType = Zt, e.margin = Ee, e.maxHeight = Ot, e.maxWidth = Ct, e.minHeight = vt, e.minWidth = St, e.mixBlendMode = P, e.objectFit = lt, e.objectPosition = bt, e.opacity = M, e.order = Oe, e.outlineColor = I, e.outlineOffset = B, e.outlineStyle = h, e.outlineWidth = D, e.overflow = dt, e.overscrollBehavior = st, e.padding = Me, e.placeContent = be, e.placeItems = he, e.placeSelf = ye, e.placeholderColor = $t, e.placeholderOpacity = eo, e.pointerEvents = Ne, e.position = ct, e.resize = Ue, e.ringColor = v, e.ringOffsetColor = W, e.ringOffsetWidth = A, e.ringOpacity = R, e.ringWidth = O, e.rotate = It, e.saturate = $, e.scale = Dt, e.screenReaders = r, e.scrollBehavior = qe, e.scrollMargin = $e, e.scrollPadding = Ze, e.scrollSnap = _e, e.sepia = ee, e.skew = jt, e.space = Ge, e.stroke = Wt, e.strokeWidth = At, e.tableLayout = j, e.textAlign = Et, e.textColor = to, e.textDecoration = Gt, e.textDecorationColor = ao, e.textDecorationStyle = qt, e.textDecorationThickness = no, e.textIndent = io, e.textOpacity = oo, e.textOverflow = Nt, e.textTransform = Lt, e.textUnderlineOffset = lo, e.touchAction = Je, e.transformOrigin = Pt, e.transitionDelay = N, e.transitionDuration = G, e.transitionProperty = E, e.transitionTimingFunction = L, e.translate = Tt, e.userSelect = Ve, e.verticalAlign = Ut, e.visibility = gt, e.whitespace = Vt, e.width = xt, e.willChange = Xe, e.wordBreak = _t, e.zIndex = yt, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});